import { TextSkeleton } from "@/components/Skeletons";
import StockPriceTooltip from "@/components/StockPriceTooltip";
import { useStockPrice } from "@/hooks/useStockPrice";
import { formatDate, formatNumber } from "devextreme/localization";

type Props = {
  ticker: string;
  assetGroupId?: string;
};

function AssetStockInfo({ ticker, assetGroupId }: Props) {
  const { data: stockData, isError, isLoading, isRefetching, isSuccess } = useStockPrice(ticker);

  const stockPrice = stockData?.data?.value;

  const displayContent = () => {
    if (isLoading || isRefetching) return <TextSkeleton height={1} />;
    else if (isSuccess) {
      return (
        <>
          <span className="absolute right-0 top-[27px]">
            {stockData?.data != null && (stockData?.hasWarning || stockData?.hasError) ? (
              <StockPriceTooltip
                ticker={ticker}
                timestamp={stockData?.data?.timestamp}
                assetGroupId={assetGroupId}
              />
            ) : null}
          </span>
          <span>
            <span className="font-medium">
              {ticker}: {displayTimestamp()}
            </span>
          </span>
          <span className="w-28">{stockPrice ? formatNumber(stockPrice, "$ #,##0.00") : "—"}</span>
        </>
      );
    } else if (isError) {
      return `Failed fetching price for stock: ${ticker}`;
    }
    return "";
  };

  const displayTimestamp = () => {
    if (!stockData?.data) {
      return `No data available`;
    } else if (stockData?.data?.timestamp) {
      return `Price as of Close ${formatDate(new Date(stockData?.data?.timestamp), "MM/dd/yyyy")}`;
    }
    return "";
  };

  return (
    <div className="mt-2 rounded-md border border-primary px-4 py-2">
      <div className="relative flex justify-between">{displayContent()}</div>
    </div>
  );
}

export default AssetStockInfo;
